<template>
	<div>
		<CModal :title="title" size="lg" :show.sync="showModal">
			<template v-if="showModal">
				<GDataTableRemote
					ref="mainTable"
					:remote-url="queryUrl"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #completedOrderItem.id="{ item }">
						<template v-if="item.completedOrderItem">
							<td>
								<router-link
									:to="`/orders/${item.completedOrderItem.parentOrder.id}/edit`"
									target="_blank">
									{{ item.completedOrderItem.id }}
								</router-link>
							</td>
						</template>
						<template v-else>
							<td><CIcon name="cil-ban" /></td>
						</template>
					</template>

					<template #salePts="{ item }">
						<template v-if="item.salePts">
							<td>[{{ item.salePts.reference }}] {{ item.salePts.name }}</td>
						</template>
						<template v-else>
							<td><CIcon name="cil-ban" /></td>
						</template>
					</template>

					<template #depotPts="{ item }">
						<template v-if="item.depotPts">
							<td>[{{ item.depotPts.reference }}] {{ item.depotPts.name }}</td>
						</template>
						<template v-else>
							<td><CIcon name="cil-ban" /></td>
						</template>
					</template>
				</GDataTableRemote>
			</template>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GDataTableRemote from '../../components/ghostlexly-components/GDataTableRemote';
	export default {
		props: {
			title: {
				type: String,
				default: 'Consultez le détail des colis',
			},
		},

		components: {
			GDataTableRemote,
		},

		data() {
			return {
				queryUrl: null,
				fields: [
					{ key: 'completedOrderItem.id', label: 'ID' },
					{ key: 'identifier', label: 'N° Bordereau' },
					{ key: 'completedOrderItem.shippingNumber', label: 'Numéro de suivi (transport)' },
					{ key: 'salePts', label: 'Point de vente' },
					{ key: 'depotPts', label: 'Point de dépôt' },
				],
				showModal: false,
			};
		},
	};
</script>
